/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * iCalendar den v týdnu
 *
 * Zdroje:
 * - [weekday v iCalendar Recurrence Rule](https://tools.ietf.org/html/rfc5545#section-3.3.10)
 * @enum {string}
 */
const IcalWeekday = {
  Sunday: 'SU',
  Monday: 'MO',
  Tuesday: 'TU',
  Wednesday: 'WE',
  Thursday: 'TH',
  Friday: 'FR',
  Saturday: 'SA'
};

export default IcalWeekday;
